import * as React from 'react';
import styled from 'styled-components';
import { SPACING, SITE_WIDTH, MEDIA_QUERIES } from '@govuk-react/constants';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _excluded = ["children"];

var _styled$withConfig;
var OuterContainer = styled('div').withConfig({
  displayName: "src__OuterContainer",
  componentId: "sc-1lvyroj-0"
})({
  paddingTop: SPACING.SCALE_5,
  textAlign: 'center'
}); // This is currently 'width-container' and not 'main' from govuk-frontend
// Maybe we should deprecate this component in favour of Page.Main and Page.WidthContainer?

var InnerContainer = styled('div').withConfig({
  displayName: "src__InnerContainer",
  componentId: "sc-1lvyroj-1"
})((_styled$withConfig = {
  maxWidth: SITE_WIDTH,
  marginLeft: SPACING.SCALE_3,
  marginRight: SPACING.SCALE_3,
  textAlign: 'left'
}, _defineProperty(_styled$withConfig, MEDIA_QUERIES.LARGESCREEN, {
  marginLeft: SPACING.SCALE_5,
  marginRight: SPACING.SCALE_5
}), _defineProperty(_styled$withConfig, '@media only screen and (min-width:1020px)', {
  margin: '0 auto'
}), _styled$withConfig));
/**
 * Provides a container which aligns to the TopNav component, is centered, and provides top padding.
 *
 * Note, this equivalent to 'width-container' from govuk-frontend.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/main
 * - https://design-system.service.gov.uk/styles/layout/#page-wrappers
 */

var Main = function Main(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(OuterContainer, props, /*#__PURE__*/React.createElement(InnerContainer, null, children));
};
Main.displayName = 'Main';
Main.defaultProps = {
  children: undefined
};

export { Main, Main as default };
